import { IOption } from '../types'
import { fetchGraphQL } from './GraphQLService'
import { AsyncProfessionList, resultToOption } from './ListResults'

/**
 * SearchResults pulls results based on a search query string
 */
export class SearchResults {
  private brandCode: string
  constructor(
    brandCode: string
  ) {
    this.brandCode = brandCode
  }

  async fetch(input: string): Promise<IOption[]> {
    try {
      const scrubbedInput = encodeURIComponent(cleanInput(input))
      const response = await fetchGraphQL(this.brandCode, scrubbedInput, "")
      if (response === null){
        throw Error("[ProfessionSearch] - A call to retrieve the searchable list failed.")
      }

      const gqlResults = response.professions?.results ?? []
      const atomResult: AsyncProfessionList = gqlResults.map(gqlItem => {
        return {
          Description: gqlItem.professionName,        // old "Description" field
          Id: parseInt(gqlItem.businessClassId, 10),  // old "Id" as number
          ForceRoute: gqlItem.forceRoute
        }
      })
      return atomResult.map(resultToOption)
    } catch (err) {
      console.log(err)
    }
    return []
  }
}

// treating this as a singleton for now
type SearchResultsInstance = false | SearchResults

let searchResultsInstance: SearchResultsInstance = false

export function getSearchResults(  
  brandCode: string
): SearchResults {
  if (searchResultsInstance === false) {
    searchResultsInstance = new SearchResults(brandCode)
  }

  return searchResultsInstance
}

function cleanInput(input: string) {
  return input.replace(/&/g, '')
}